import { FunctionComponent } from 'react';

import { Props } from './index';
import StyledComponent from './styles';

const PublicLayoutNavigationCompanyPhoneIconSide: FunctionComponent<Props> = ({ phoneIcon }) => {
    return (
        <StyledComponent className="public-layout-navigation-company-phone-icon-side">
            <a
                href={`tel:${phoneIcon?.phoneLink}`}
                className="phone-icon"
            >
                <img
                    className="icon"
                    src={phoneIcon?.icon}
                    loading="lazy"
                    alt={phoneIcon?.alt}
                />
                <span
                    className="phone"
                    dangerouslySetInnerHTML={{ __html: phoneIcon?.phone }}
                />
            </a>
        </StyledComponent>
    );
};

export default PublicLayoutNavigationCompanyPhoneIconSide;